import React, { memo, useContext } from "react";
import { Data } from "../App";

function PrefSelect({ dtRef, ddRef }) {
  const { formData, setFormData, errors, setErrors } = useContext(Data);

  function onChange(e) {
    setFormData({ ...formData, pref: e.target.value });
    if (e.target.value === "") {
      setErrors({ ...errors, pref: "必須項目です" });
      dtRef.current.style.backgroundColor = "#FFDBDB";
      ddRef.current.style.backgroundColor = "#FFF2F2";
    } else {
      setErrors({ ...errors, pref: null });
      dtRef.current.style.backgroundColor = "#DBF0FF";
      ddRef.current.style.backgroundColor = "#F2F9FF";
    }
  }

  return (
    <>
      <div className="select">
        <select onChange={(e) => onChange(e)} value={formData.pref}>
          <option value="">-選択してください</option>
          <optgroup label="北海道・東北">
            <option value="北海道">北海道</option>
            <option value="青森県">青森県</option>
            <option value="岩手県">岩手県</option>
            <option value="宮城県">宮城県</option>
            <option value="秋田県">秋田県</option>
            <option value="山形県">山形県</option>
            <option value="福島県">福島県</option>
          </optgroup>
          <optgroup label="関東">
            <option value="茨城県">茨城県</option>
            <option value="栃木県">栃木県</option>
            <option value="群馬県">群馬県</option>
            <option value="埼玉県">埼玉県</option>
            <option value="千葉県">千葉県</option>
            <option value="東京都">東京都</option>
            <option value="神奈川県">神奈川県</option>
          </optgroup>
          <optgroup label="甲信越・北陸">
            <option value="新潟県">新潟県</option>
            <option value="富山県">富山県</option>
            <option value="石川県">石川県</option>
            <option value="福井県">福井県</option>
            <option value="山梨県">山梨県</option>
            <option value="長野県">長野県</option>
          </optgroup>
          <optgroup label="東海">
            <option value="岐阜県">岐阜県</option>
            <option value="静岡県">静岡県</option>
            <option value="愛知県">愛知県</option>
            <option value="三重県">三重県</option>
          </optgroup>
          <optgroup label="近畿">
            <option value="滋賀県">滋賀県</option>
            <option value="京都府">京都府</option>
            <option value="大阪府">大阪府</option>
            <option value="兵庫県">兵庫県</option>
            <option value="奈良県">奈良県</option>
            <option value="和歌山県">和歌山県</option>
          </optgroup>
          <optgroup label="中国">
            <option value="鳥取県">鳥取県</option>
            <option value="島根県">島根県</option>
            <option value="岡山県">岡山県</option>
            <option value="広島県">広島県</option>
            <option value="山口県">山口県</option>
          </optgroup>
          <optgroup label="四国">
            <option value="徳島県">徳島県</option>
            <option value="香川県">香川県</option>
            <option value="愛媛県">愛媛県</option>
            <option value="高知県">高知県</option>
          </optgroup>
          <optgroup label="九州">
            <option value="福岡県">福岡県</option>
            <option value="佐賀県">佐賀県</option>
            <option value="長崎県">長崎県</option>
            <option value="熊本県">熊本県</option>
            <option value="大分県">大分県</option>
            <option value="宮崎県">宮崎県</option>
            <option value="鹿児島県">鹿児島県</option>
            <option value="沖縄県">沖縄県</option>
          </optgroup>
        </select>
      </div>
      <small className="errorMessage">{errors.pref}</small>
    </>
  );
}

export default memo(PrefSelect);
